import styled from 'styled-components';

export const Panel = styled.footer`
  background: white;
  height: 6rem;
  font-size: 1.5rem;
  z-index: 1;
  display: flex;
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const Copyright = styled.div`
  font-size: 1.5rem;
  font-weight: normal;
  color: #222222;
`; 